export async function apiRequest(
	url: RequestInfo | URL = "", 
	optionsObj: RequestInit | undefined = undefined, 
	errorMsg: string | null  = null 
): Promise<JSON | string | null> {
	try {
		const result = await fetch(url, optionsObj);
		if (!result.ok) {
			const error = "error-" + result.status;
			throw new Error(error);
		}
		return await result.json();
	}
	catch (err) {
		const error = err as Error;
		if (error.name === "AbortError") 
			return null;
		return errorMsg = error.message;
	}
}

export async function apiPOST(
	url: string | undefined, 
	formData: FormData | undefined = undefined, 
	abortControllerSignal?: AbortSignal | null | undefined
): Promise<JSON | string | null> {
	return await apiRequest(
		url,
		abortControllerSignal ?
		{
			method: "POST",
			body: formData,
			signal: abortControllerSignal
		} :
		{
			method: "POST",
			body: formData
		}
	)
}

export async function apiGET(
	url: string | undefined,
	getHeaders: Headers,
	abortControllerSignal?: AbortSignal | null | undefined
): Promise<JSON | string | null> {
	
	return await apiRequest(
		url,
		abortControllerSignal ?
		{
			method: "GET",
			headers: getHeaders,
			signal: abortControllerSignal,
			redirect: "follow"
		} :
		{
			method: "GET",
			headers: getHeaders,
			redirect: "follow"
		}
	)
}

export async function apiPOSTnew(
	url: string | undefined,
	postHeaders: Headers,
	bodyInit: BodyInit | null,
	abortControllerSignal?: AbortSignal | null | undefined
): Promise<JSON | string | null> {
	

	return await apiRequest(
		url,
		abortControllerSignal ?
		{
			method: "POST",
			headers: postHeaders,
			body: bodyInit,
			signal: abortControllerSignal,
			redirect: "follow"
		} :
		{
			method: "POST",
			headers: postHeaders,
			body: bodyInit,
			redirect: "follow"
		}
	)
}

// unused, now just a raw jason loading example
/*
export async function getEnvUrls(configUrl:string, abortControllerSignal?: AbortSignal | null | undefined): Promise<JSON | string> {
	try {
		const result = await fetch(
			configUrl, 
			abortControllerSignal ?
			{
				headers : { 
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				},
				signal: abortControllerSignal
			} :
			{
				headers : { 
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				}
			}
		);
		if (!result.ok) {
			const error = "Error " + result.status;
			return error;
		}
		return await result.json();
	}
	catch (err) {
		return (err as Error).message;
	}
}
*/